const FormationList = require('ffss/component/row/formation/List');

class ClubDetail{
    defaultOptions() {
        return {
        	'$container': null,
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onSubmit = this.onSubmit.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);
        this.onClickNext = this.onClickNext.bind(this);

        this.$container = this.settings.$container;
        if(!this.$container){
        	window.notify("$container is missing in component/row/ClubDetail","error");
        }

        this.$listContainer = $('.formation-search-list',this.$container);
        this.$noResultContainer = $('.formation-search-noresult',this.$container);

        this.$form = $('.formation-search-form',this.$container);
        this.$resultContainer = $('.formation-search-result-container',this.$container);
        this.$loader = $('.formation-search-loader',this.$container);
        this.$diplomeTitle = $('.formation-search-diplome-title',this.$container);
        this.$diplomeDescription = $('.formation-search-diplome-description',this.$container);

        this.$filterDiplome = $('select[name="diplome"]',this.$form);
        this.$filterRegion = $('select[name="region"]',this.$form);
        this.$filterOrganisme = $('input[name="organisme"]',this.$form);
        this.$filterPeriod = $('input[name="period"]',this.$form);

        this.currentOffset = 0;
        this.currentRequest =  null;

        this.initialize();
    }

    initialize(){
    	var self = this;


    	this.$form.on('submit',this.onSubmit);
		this.$filterDiplome.on('change',this.onFilterChange);
		this.$filterRegion.on('change',this.onFilterChange);
		this.$filterOrganisme.on('change',this.onFilterChange);
		this.$filterPeriod.on('change',this.onFilterChange);

		this.list = new FormationList({
			'$container': this.$listContainer,
			'onClickNext': this.onClickNext,
			'mode': 'club',
		});

		this.$form.trigger('submit');
    }

    showList(){
		this.$listContainer.show();
    }

    onFilterChange(event){
    	let $filter = $(event.target);

    	let filterName = $filter.attr('name');

    	switch(filterName){
    		case 'diplome':
    			this.onChangeDiplome();
			break;

    		case 'region':
    			this.onChangeRegion();
			break;

    		case 'organisme':
    			this.onChangeOrganisme();
			break;
    	}

    	this.currentOffset = 0;

    	if(this.canSubmit()){
    		this.$form.trigger('submit');
    	}
    }

    canSubmit(){
    	let idDiplome = this.$filterDiplome.val();
    	let idRegion = this.$filterRegion.val();
    	let idOrganisme = this.$filterOrganisme.val();
    	let period = this.$filterPeriod.val();

    	return true;
    }

    onChangeDiplome(){
    	let idDiplome = this.$filterDiplome.val();

		this.$diplomeTitle.html('');
		this.$diplomeDescription.html('');

		let $diplome = $('option[value="'+idDiplome+'"]',this.$filterDiplome);
		if($diplome.length > 0){
			this.$diplomeTitle.append($diplome.text());
			this.$diplomeDescription.append($($diplome.data('description')).text());
		}
    }

    onChangeRegion(){
    	let idRegion = this.$filterRegion.val();

    	if(idRegion){
	    	let idOrganisme = this.$filterOrganisme.val();
	    	if(idOrganisme){
	    		let $organisme = $('option[value="'+idOrganisme+'"]',this.$filterOrganisme);
	    		if($organisme.data('region') != idRegion){
	    			this.$filterOrganisme.val("").trigger('change');
	    		}
	    	}
    		$('option',this.$filterOrganisme).data('hidden',true);
    		$('option[data-region="'+idRegion+'"]',this.$filterOrganisme).data('hidden',false);
    		$('option[value=""]',this.$filterOrganisme).data('hidden',false);
	    }else{
	    	$('option',this.$filterOrganisme).data('hidden',false);
	    }

	    this.$filterOrganisme.select2('destroy');
	    this.$filterOrganisme.select2({
            templateResult: function(option) {
                let $option = $(option.element);
                if($option.data('hidden')){
                    return null;
                }
                return option.text;
            }
        });
    }

    onChangeOrganisme(){
    	let idOrganisme = this.$filterOrganisme.val();
    	if(idOrganisme){
    		let $organisme = $('option[value="'+idOrganisme+'"]',this.$filterOrganisme);
    		let idRegion = $organisme.data('region');
			this.$filterRegion.val(idRegion).trigger('change');
    	}
    }

    onSubmit(event){
		event.preventDefault();
		event.stopPropagation();

		this.doSubmit(true);

    }

    getData(){
    	let data  = this.$form.serializeArray();

    	data.push({
    		'name': 'mode',
    		'value': 'public',
    	});

    	data.push({
    		'name': 'start',
    		'value': this.currentOffset
    	});

    	data.push({
    		'name': 'length',
    		'value': 30,
    	});

    	return data;
    }

    doSubmit(clearList){
    	var self = this;
        
        if(this.currentRequest != null){
            this.currentRequest.abort();
        }

		this.$resultContainer.show();
		this.$loader.show();
		this.$noResultContainer.hide();
		if(clearList){
			this.$listContainer.hide();
		}
		this.list.setNeedClear(clearList);

    	let data = this.getData();

        this.currentRequest = $.ajax({
    		'url': this.$form.attr('action'),
    		'method': this.$form.attr('method'),
    		'data': data
    	})
    	.done(function(xhr){
    		if(xhr.success){
    			self.showResult(xhr);
    		}else{
    			window.notify("todo notification of error : "+ xhr.message,"error");
    		}
    	})
    	.fail(function(){
    		window.notify("todo notification of error","error");
    	})
    	.always(function(){
    		self.$loader.hide();
    	});

    }

    showResult(xhr){
    	let data = xhr.data;
    	if(data.length == 0){
    		this.$noResultContainer.show();
    	}else{
    		this.fillListWithResult(xhr);
    		this.$listContainer.show();
	    }
    }


	fillListWithResult(data){
		this.list.setData(data);
	}

	onClickNext(offset){
		this.currentOffset = offset;

		this.doSubmit(false);
	}

}

module.exports = ClubDetail;